export default "__VITE_ASSET__CA7X2dLE__"